import(/* webpackMode: "eager", webpackExports: ["CustomerLogosSection"] */ "/app/apps/todoist-landing-pages/app/[locale]/home/customer-logos-section/customer-logos-section.tsx");
;
import(/* webpackMode: "eager" */ "/app/apps/todoist-landing-pages/app/[locale]/home/hero/hero.module.css");
;
import(/* webpackMode: "eager", webpackExports: ["IllustrationScene"] */ "/app/apps/todoist-landing-pages/app/[locale]/home/hero/illustration-scene.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Prefooter"] */ "/app/apps/todoist-landing-pages/app/[locale]/home/prefooter/prefooter.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ProductScenesSection"] */ "/app/apps/todoist-landing-pages/app/[locale]/home/product-scenes-section/product-scenes-section.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["StatsSection"] */ "/app/apps/todoist-landing-pages/app/[locale]/home/stats-section/stats-section.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TemplateListDesktop"] */ "/app/apps/todoist-landing-pages/app/[locale]/home/templates-section/template-list-desktop.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TemplateListMobile"] */ "/app/apps/todoist-landing-pages/app/[locale]/home/templates-section/template-list-mobile.tsx");
;
import(/* webpackMode: "eager" */ "/app/apps/todoist-landing-pages/app/[locale]/home/templates-section/templates-section.module.css");
;
import(/* webpackMode: "eager", webpackExports: ["VideoPlayer"] */ "/app/apps/todoist-landing-pages/app/[locale]/home/video-section/video-player.tsx");
;
import(/* webpackMode: "eager" */ "/app/apps/todoist-landing-pages/app/[locale]/home/video-section/video-section.module.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/apps/todoist-landing-pages/app/components/footer/footer.tsx");
;
import(/* webpackMode: "eager" */ "/app/apps/todoist-landing-pages/app/components/handwritten-box/handwritten-box.module.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/apps/todoist-landing-pages/app/components/header/header.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Box"] */ "/app/apps/todoist-landing-pages/app/components/marketist.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["StartForFreeButton"] */ "/app/apps/todoist-landing-pages/app/components/start-for-free-button.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["UserContextV2Provider"] */ "/app/apps/todoist-landing-pages/app/services/providers/contexts/user-context.tsx");
;
import(/* webpackMode: "eager" */ "/app/apps/todoist-landing-pages/components/reviews-counter/reviews-counter.module.css");
;
import(/* webpackMode: "eager" */ "/app/apps/todoist-landing-pages/public/static/teams/handwritten-box/desktop-arrow.svg");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/next-intl/dist/esm/shared/NextIntlClientProvider.js");
